import { TOP_X, TOP_Y } from '../constants';

export class Participant {
  type: 'actor' | 'entity';
  name: string;
  x: number = TOP_X;
  y: number = TOP_Y;

  constructor(line: string) {
    const participantArray = line.split(' ');
    this.type = participantArray.shift() as 'actor' | 'entity';
    this.name = participantArray.join(' ');
  }
}
